/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Stripe_Signing_SecretInputs */

const en_admin_settings_fields_stripe_signing_secret = /** @type {(inputs: Admin_Settings_Fields_Stripe_Signing_SecretInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webhook Signing Secret`)
};

const zh_admin_settings_fields_stripe_signing_secret = /** @type {(inputs: Admin_Settings_Fields_Stripe_Signing_SecretInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webhook 签名密钥`)
};

/**
* | output |
* | --- |
* | "Webhook Signing Secret" |
*
* @param {Admin_Settings_Fields_Stripe_Signing_SecretInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_stripe_signing_secret = /** @type {((inputs?: Admin_Settings_Fields_Stripe_Signing_SecretInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Stripe_Signing_SecretInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_stripe_signing_secret(inputs)
	return zh_admin_settings_fields_stripe_signing_secret(inputs)
});
export { admin_settings_fields_stripe_signing_secret as "admin.settings.fields.stripe_signing_secret" }